import React, { PureComponent } from 'react'
import { Text } from '../Typography'
import { translate } from '../../../services/translate'

class TranslatedText extends PureComponent {
  render () {
    const { value, default: defaultValue, ...rest } = this.props
    return (
      <Text {...rest}>
        {translate(value, defaultValue)}
      </Text>
    )
  }
}

export default TranslatedText
